import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOwnApplyJobs } from "../../slice/workerResumeSlice";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";

const WorkerApplyJob = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ownApplyJobs, loading, error } = useSelector(
        (state) => state.workerResume
    );
    const token = localStorage.getItem("token");
    const [showModal, setShowModal] = useState(false);
    const [selectedApplication, setSelectedApplication] = useState(null);

    const [status, setStatus] = useState("");
    const [salaryType, setSalaryType] = useState("");
    const [salary, setSalary] = useState("");
    const [duration, setDuration] = useState("");

    const [filters, setFilters] = useState({
        keyword: "",
        status: "",
        date: "",
    });
    useEffect(() => {
        console.log("api called");
        if (!token) return;

        dispatch(getOwnApplyJobs({ token, filters }));
    }, [token, dispatch]);
    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case "applied":
                return "bg-primary";
            case "shortlisted":
                return "bg-info text-dark";
            case "rejected":
                return "bg-danger";
            case "interview":
                return "bg-warning text-dark";
            case "accepted":
                return "bg-success";
            default:
                return "bg-secondary";
        }
    };

    console.log("ownApplyJobs", ownApplyJobs);

    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
            <div className="ps-2 ps-lg-4">
                <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-3 border-bottom">
                    My Applied Jobs
                </h4>

                {/* FILTER BAR */}
                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <div className="row g-3 align-items-end">

                            {/* Keyword */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Keyword</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search keyword..."
                                    value={filters.keyword}
                                    onChange={(e) =>
                                        setFilters({ ...filters, keyword: e.target.value })
                                    }
                                />
                            </div>

                            {/* Status */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Status</label>
                                <select
                                    className="form-select"
                                    value={filters.status}
                                    onChange={(e) =>
                                        setFilters({ ...filters, status: e.target.value })
                                    }
                                >
                                    <option value="">All Status</option>
                                    <option value="applied">Applied</option>
                                    <option value="shortlisted">Shortlisted</option>
                                    <option value="interview">Interviewed</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            {/* Job */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="Search keyword..."
                                    value={filters.date}
                                    onChange={(e) =>
                                        setFilters({ ...filters, date: e.target.value })
                                    }
                                />
                            </div>

                            {/* Buttons */}
                            <div className="col-md-2 d-flex gap-2">
                                <button
                                    className="btn btn-primary w-100"
                                    onClick={() => dispatch(getOwnApplyJobs({ token, filters }))}
                                    disabled={loading}
                                >
                                    Apply
                                </button>

                                <button
                                    className="btn btn-outline-secondary w-100"
                                    onClick={() => {
                                        const cleared = { keyword: "", status: "", date: "" };
                                        setFilters(cleared);
                                        dispatch(getOwnApplyJobs({ token, filters: cleared }));
                                    }}
                                >
                                    Clear
                                </button>
                            </div>

                        </div>
                    </div>
                </div>


                {/* LOADING */}
                {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}

                {/* ERROR */}
                {error && <p className="text-danger">{error}</p>}

                {/* EMPTY STATE */}
                {!loading && ownApplyJobs?.length === 0 && (
                    <p className="text-muted">You have not applied to any jobs yet.</p>
                )}

                {/* APPLICATION LIST */}
                {!loading && ownApplyJobs?.length > 0 && (
                    <div className="card shadow-sm">
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th className="font-weight-semibold">Cover Letter</th>
                                        <th className="font-weight-semibold">Job Title</th>
                                        <th className="font-weight-semibold">Status</th>
                                        <th className="font-weight-semibold">Applied On</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    {ownApplyJobs.map((app, index) => (
                                        <tr key={app.id}>

                                            <td>{app.cover_letter}</td>
                                            <td><Link to={`/job-details/${app.job_id}`} className="text-decoration-none">
                                                {app.job.title}
                                            </Link></td>

                                            <td>
                                                <span className={`badge ${getStatusClass(app.status)} text-uppercase`}>
                                                    {app.status}

                                                </span><br />
                                                <b>
                                                    {app.salary != null && app.salary_type ? `${app.salary} | ${app.salary_type}` : `${app.salary || app.salary_type || ""}`}
                                                </b>
                                            </td>
                                            <td>{app.applied_at}</td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

};

export default WorkerApplyJob;